import React from 'react';

const Contact = () => {
  return (
    <section id="contact" className="py-20 bg-background text-white">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-8">Book an Escort in Noida</h2>
        <div className="max-w-xl mx-auto text-center">
          <p className="text-lg mb-4">To book an escort, please contact us directly through WhatsApp or by phone.</p>
          <div className="flex justify-center space-x-4">
            <a href="tel:+917838380756" className="bg-primary text-white font-bold py-3 px-8 rounded-full text-lg hover:bg-opacity-80 transition duration-300 ease-in-out transform hover:scale-105">
              Call Now
            </a>
            <a href="https://wa.me/917838380756" target="_blank" rel="noopener noreferrer" className="bg-green-500 text-white font-bold py-3 px-8 rounded-full text-lg hover:bg-opacity-80 transition duration-300 ease-in-out transform hover:scale-105">
              WhatsApp
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
